import React, { useState, useEffect } from "react";
import Card from "../../../components/Card";
import { Row, Col, Form, Button,Table } from "react-bootstrap";
import { toast } from 'react-toastify';
import { postApiCall , getApiCall} from "../../../service/httpCall";
import { API_FLASH_MESSAGE_CREATE , API_MODULE_LIST, API_FLASH_MESSAGE_LIST} from "../../../service/url";
import { useNavigate } from "react-router-dom";
import {
  ROUTES,
} from "../../../utilities/constant";
import { FLASH_MESSAGE_ACTION, FLASH_MESSAGE_TYPE } from "../../../utilities/constant";



export default function FlashMessageCreate() {
  const navigate = useNavigate();
  const [buttonDisable, setButtonDisable] = useState(false);
  const [moduleList, setModuleList] = useState([]);
  const [selectedModule, setSelectedModule] = useState("");
  const [action, setAction] = useState('');
  const [type, setType] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
      getApiCall(API_MODULE_LIST, {})
        .then(onModuleListSuccess)
        .catch(onError);
  }, []);

  function onModuleListSuccess(resp) {
      setModuleList(resp)
  }

  function onError(err) {
     console.log(err)
  }
  useEffect(() => {
  }, []);

  function validateForm() {
    if (!selectedModule) {
      toast.warning("Module is required");
      return false;
    }

    if (!action) {
      toast.warning("Action is required");
      return false;
    }

    if (!message) {
      toast.warning("Message is required");
      return false;
    }

    return true;
  }

  function submitForm(e) {
    e.preventDefault();

    if (!validateForm()) return;

    setButtonDisable(true);

    const params = {
      module_name: selectedModule,
      action: action,
      message: message,
      type:type
    };

    postApiCall(API_FLASH_MESSAGE_CREATE, params)
      .then(onSuccess)
      .catch(onError);
  }

  function onSuccess(resp) {
    toast.success("Flash message created successfully");
    setTimeout(() => {
      navigate(`/${API_FLASH_MESSAGE_LIST || ""}`);
    }, 1500);
  }

  function onError(err) {
    setButtonDisable(false);
    toast.warning(err);
  }

  return (
    <>
      <div>
        <Row>
          <Col xl="12" lg="12">
            <Card>
              <Card.Header className="d-flex justify-content-between">
                <div className="header-title">
                  <h4 className="card-title">
                    New Flash Message Information
                  </h4>
                </div>
              </Card.Header>
              <Card.Body>
                <div className="new-trunk-info">
                <form onSubmit={submitForm}>
                  <div className="row">

                    {/* Module Dropdown */}
                    <Form.Group className="col-md-4 form-group">
                      <Form.Label>
                        Module <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Select
                        value={selectedModule}
                        onChange={(e) => setSelectedModule(e.target.value)}
                      >
                        <option value="">Select Module</option>
                        {moduleList.map((item, index) => (
                          <option key={index} value={item.module_name}>
                            {item.module_name}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>

                    {/* Action Dropdown */}
                    <Form.Group className="col-md-4 form-group">
                      <Form.Label>
                        Action <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Select
                        value={action}
                        onChange={(e) => setAction(e.target.value)}
                      >
                        <option value="">Select Action</option>
                        {FLASH_MESSAGE_ACTION.map((item, index) => (
                          <option key={index} value={item}>
                            {item}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>

                    <Form.Group className="col-md-4 form-group">
                      <Form.Label>
                        Type <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Select
                        value={type}
                        onChange={(e) => setType(e.target.value)}
                      >
                        <option value="">Select Type</option>
                        {FLASH_MESSAGE_TYPE.map((item, index) => (
                          <option key={index} value={item}>
                            {item}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>

                    {/* Message Textarea */}
                    <Form.Group className="col-md-12 form-group">
                      <Form.Label>
                        Message <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={4}
                        placeholder="Enter Flash/Note message..."
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                      />
                    </Form.Group>

                  </div>

                  <Button
                    type="submit"
                    variant="primary"
                    disabled={buttonDisable}
                  >
                    Add Flash Message&nbsp;
                    {buttonDisable && (
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                      ></span>
                    )}
                  </Button>
                </form>
                </div>

              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>

    </>
  );
}
